module.exports = __webpack_public_path__ + "static/media/20ECE14.489c38f2.jpg";